import React from 'react';
import { useNavigate } from 'react-router-dom'; // 🌟 IMPORT ROUTER NAVIGATION HOOK

const CategoryGrid = () => {
  const navigate = useNavigate(); // Initialize the engine

  return (
    <section className="max-w-[1400px] mx-auto px-6 mb-32">
      <h2 className="text-center text-[10px] uppercase tracking-[0.5em] text-[#664229] mb-16 opacity-60 font-bold">
        Browse Collections
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 h-auto md:h-[800px]">
        
        {/* MEN SECTION */}
        <div className="md:col-span-4 grid grid-rows-2 gap-6 h-full">
          {/* Men Regular Fit */}
          <div 
            onClick={() => navigate('/collection/men-regular')} // 🌟 REDIRECTS TO EXCLUSIVE VIEW PATH
            className="bg-[#E5D3B3] p-8 flex flex-col justify-end group cursor-pointer overflow-hidden relative"
          >
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/[0.03] transition-all duration-700 pointer-events-none" />
            <span className="text-[10px] uppercase tracking-widest opacity-50 mb-2">Collection</span>
            <h3 className="text-lg font-bold tracking-tighter text-[#2C1E12]">MEN — <br />REGULAR FIT</h3>
          </div>
          
          {/* Men Oversized */}
          <div 
            onClick={() => navigate('/collection/men-oversized')}
            className="bg-[#E5D3B3] p-8 flex flex-col justify-end group cursor-pointer overflow-hidden relative"
          >
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/[0.03] transition-all duration-700 pointer-events-none" />
            <span className="text-[10px] uppercase tracking-widest opacity-50 mb-2">Style</span>
            <h3 className="text-lg font-bold tracking-tighter text-[#2C1E12]">MEN — <br />OVERSIZED</h3>
          </div>
        </div>

        {/* UNISEX SECTION */}
        <div 
          onClick={() => navigate('/collection/unisex')}
          className="md:col-span-4 bg-[#E5D3B3] p-10 flex flex-col justify-center items-center group cursor-pointer overflow-hidden relative border-x border-[#F5F5DC]"
        >
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/[0.05] transition-all duration-700 pointer-events-none" />
          <h3 className="text-3xl font-bold tracking-[0.3em] text-[#2C1E12] border-b-2 border-[#2C1E12] pb-4">UNISEX</h3>
          <p className="mt-6 text-[10px] uppercase tracking-widest opacity-60 font-bold italic">Signature Pieces</p>
        </div>

        {/* WOMEN SECTION */}
        <div className="md:col-span-4 grid grid-rows-2 gap-6 h-full">
          {/* Women Regular Fit */}
          <div 
            onClick={() => navigate('/collection/women-regular')}
            className="bg-[#E5D3B3] p-8 flex flex-col justify-end group cursor-pointer overflow-hidden relative text-right items-end"
          >
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/[0.03] transition-all duration-700 pointer-events-none" />
            <span className="text-[10px] uppercase tracking-widest opacity-50 mb-2">Collection</span>
            <h3 className="text-lg font-bold tracking-tighter text-[#2C1E12]">WOMEN — <br />REGULAR FIT</h3>
          </div>
          
          {/* Women Oversized */}
          <div 
            onClick={() => navigate('/collection/women-oversized')}
            className="bg-[#E5D3B3] p-8 flex flex-col justify-end group cursor-pointer overflow-hidden relative text-right items-end"
          >
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/[0.03] transition-all duration-700 pointer-events-none" />
            <span className="text-[10px] uppercase tracking-widest opacity-50 mb-2">Style</span>
            <h3 className="text-lg font-bold tracking-tighter text-[#2C1E12]">WOMEN — <br />OVERSIZED</h3>
          </div>
        </div>

      </div>
    </section>
  );
};

export default CategoryGrid;